import { observer } from "mobx-react";
import { useEffect } from "react";

import InputLink from "components/InputLink/InputLink";
import TextBlock from "components/UI/TextBlock/TextBlock";
import UploadFile from "components/UploadFile/UploadFile";

import { useMatchMedia } from "utils/hooks/use-match-media";

import clipIcon from "assets/images/clip.svg";

import "./SettingsSeoOther.scss";

const SettingsSeoOther = observer(({ store, linkRef, screenshotRef, googleSeo }) => {
  const { isMobile } = useMatchMedia();

  useEffect(() => {
    store.setPfYandex(googleSeo ? 'google' : 'yandex');
    store.setIsProgrevSsylok(googleSeo);
  }, [googleSeo, store]);

  const onChangeLinkToAd = (e) => {
    store.setLinkToAd(e.target.value);
  };

  return (
    <div className="settings-seo-other__container">
      <div className="settings-seo-other__container-input" ref={linkRef}>
        <div className="settings-seo-step__title">
          <TextBlock title="Укажите ссылку на сайт-донор" titleClassName="settings-seo-step__label" />
          {!isMobile && <TextBlock title="С указанного URL пользователи перейдут на ваш сайт" titleClassName="settings-seo-step__sublabel" />}
        </div>
        <InputLink defaultValue={store.linkToAd} onChange={onChangeLinkToAd} errortext={store.linkError} />
      </div>

      <div className="settings-seo-other__container-uploaded" ref={screenshotRef}>
        <div className="settings-seo-step__title">
          <TextBlock title="Где искать ссылку на продвигаемый сайт?" titleClassName="settings-seo-step__label" />
        </div>
        <div className="settings-seo-other__container-uploaded_data">
          <TextBlock title="Страница, заголовок блока и все, что поможет исполнителю найти ссылку на ваш сайт" titleClassName="settings-seo-other__container-uploaded_data-info" />
          <UploadFile
            className="settings-seo-other__add-button"
            fileType="linkScreenshot"
            title="Добавить фото"
            icon={clipIcon}
          />
        </div>
      </div>
    </div>
  );
});

export default SettingsSeoOther;
